const navbar = document.querySelector("#navbar");
const backTopBtn = document.querySelector("#btn-backTop");
window.addEventListener("scroll", (e) => {
  if (window.scrollY !== 0) {
    navbar.classList.add("navbar--active");
  } else if (window.scrollY === 0) {
    navbar.classList.remove("navbar--active");
  }
  if (window.scrollY >= window.innerHeight / 2) {
    backTopBtn.classList.add("fade-in");
  } else {
    backTopBtn.classList.remove("fade-in");
  }
});

backTopBtn.addEventListener("click", (e) => {
  e.preventDefault;
  screenTop = 0;
});

AOS.init();

const header = document.querySelector("header");
const pageName = header.getAttribute("data-page");
const navItem = document.querySelectorAll(".nav-link");
window.addEventListener("load", function () {
  navItem.forEach((i) => {
    if (pageName === i.getAttribute("data-navLink")) {
      i.classList.add("nav-link--active");
    }
  });
});

// init Masonry
var $grid = $(".grid").masonry({
  itemSelector: ".grid-item",
  percentPosition: true,
  columnWidth: ".grid-sizer",
});
// layout Masonry after each image loads
$grid.imagesLoaded().progress(function () {
  $grid.masonry();
});
